import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKakao = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		id: "Type=Kakao Pay",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Vector",
			clipPath: "url(#clip0_13_5710_kakao_dark)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.5971 7C10.0586 7 8 8.70726 8 10.8136C8 12.0773 8.74295 13.1961 9.88469 13.8901L9.34364 16.0123C9.29191 16.216 9.50818 16.3775 9.67488 16.2605L12.023 14.5963C12.212 14.6159 12.4031 14.6272 12.5978 14.6272C15.1371 14.6272 17.195 12.92 17.195 10.8144C17.195 8.70877 15.1364 7 12.5971 7ZM21.2668 8.8242V12.9954C21.3645 13.0082 21.6074 13.0339 21.8381 13.0339C23.1012 13.0339 23.5877 12.1029 23.5877 10.6356C23.5877 9.34701 23.2593 8.5692 22.2512 8.5692C21.9228 8.5692 21.5585 8.67105 21.2668 8.8242ZM21.2668 14.2968V16.892H19.4935V7.26782H20.7445L20.9629 7.88041C21.3394 7.48509 21.9106 7.06413 22.8339 7.06413C24.5713 7.06413 25.3969 8.42888 25.3854 10.6363C25.3854 12.9449 24.11 14.425 22.2871 14.425C21.9351 14.425 21.6685 14.3994 21.2668 14.2975M29.9782 12.4432V11.1674H29.1641C28.253 11.1674 27.791 11.5122 27.791 12.201C27.791 12.7238 28.0461 12.9796 28.5685 12.9796C29.0542 12.9796 29.6743 12.7238 29.9782 12.4432ZM28.9694 9.98073H29.9782V9.75138C29.9782 8.98564 29.5651 8.62805 28.848 8.62805C28.3019 8.62805 27.597 8.79402 27.0258 9.08749L26.5394 7.83741C27.1717 7.37797 28.1431 7.05885 29.0053 7.05885C30.7068 7.05885 31.6301 8.00263 31.6301 9.80117V14.2281H30.3784L30.1959 13.6412C29.4796 14.1897 28.8235 14.4198 28.2279 14.4198C26.9281 14.4198 26.1995 13.6035 26.1995 12.2259C26.1995 10.7585 27.1717 9.98073 28.9694 9.98073ZM36.9227 13.6336C36.3034 15.3688 35.5619 16.631 34.4805 17.3326L33.3876 16.2734C34.0192 15.6993 34.4683 15.138 34.857 14.3858L32.5002 7.63749L34.2621 7.14032L35.7681 12.6129L37.2626 7.11467L39 7.62542L36.922 13.6336H36.9227Z",
				fill: "white"
			})
		})
	}) }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_13_5710_kakao_dark",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 31,
			height: 9.84162,
			fill: "white",
			transform: "translate(8 7)"
		})
	}) })]
});
export default SvgKakao;
